import React, { useState } from "react";
import Cursor from "../../Components/Cursor"; import Header from "../../Components/Header";
import ActiveTestimonial from "../../Components/ActiveTestimonial";
import Testimonials from "../../Components/Testimonials";
import "../../assets/css/Testimonial.css";
import img1 from '../../assets/images/testimonial1.webp';
import img2 from '../../assets/images/testimonial2.webp';
import img3 from '../../assets/images/testimonial3.webp';
import img4 from '../../assets/images/testimonial4.webp';
import { ServicesSectionProvider } from "../../Context/ServiceSectionContext";
import { useEffect } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { Helmet } from "react-helmet";


const testimonialsData = [
    {
        name: "John Carter",
        title: "CEO at Business 360",
        detail: "Glyph is our go-to partner for cutting-edge tech solutions. Hamza Ansari and his team consistently exceed expectations with their professionalism and forward-thinking approach. They’ve played a pivotal role in scaling our business and optimizing our operations. We trust Glyph for all our tech needs!",
        image: img1,
    },
    {
        name: "Matt Cannon",
        title: "Founder at Xearth",
        detail: "Working with Hamza Ansari and the Glyph team has been a game-changer for Xearth. Their ability to solve complex tech challenges with innovative solutions has helped us stay ahead of the curve. I highly recommend Glyph for any tech-related services – they deliver beyond expectations!",
        image: img2,
    },
    {
        name: "Sophie Moore",
        title: "CTO at Coding Chamber",
        detail: "Glyph, led by Hamza Ansari, transformed our tech needs into seamless solutions. Their team’s expertise and innovation have been key to our success. Working with them has been a game changer for Coding Chamber. Highly recommended for anyone seeking top-tier tech services!",
        image: img3,
    },
    {
        name: "Brian Cranston",
        title: "CFO at Heisenberg",
        detail: "Glyph has been instrumental in transforming our technology strategy. Their innovative solutions and commitment to excellence have helped us streamline operations and achieve remarkable growth. The team, led by Hamza Ansari, always brings fresh ideas to the table, and their expertise in the tech space is unmatched. We are grateful for their partnership and look forward to continuing this journey together.",
        image: img4,
    }

];

const Testimonial = () => {
    const [testimonials, setTestimonials] = useState([])
    const [activeTestimonial, setActiveTestimonial] = useState([]);
    const [loading, setLoading] = useState(true)

    const fetchTestimonial = async () => {
        try {
            setLoading(true);
            const response = await axios.get('https://api.glyphqai.com/api/get-testimonals');
            setTestimonials(response.data.testimonals);
            setActiveTestimonial(response.data.testimonals[0]);
            toast('Testimonial Fetched Successfully', response.data.testimonals);
        } catch (err) {
            toast.error('Failed to fetch Services:', err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchTestimonial();
    }, [])

    const handleTestimonialClick = (testimonial) => {
        setActiveTestimonial(testimonial);
    };

    return (
        <>
            <Helmet>
                <title>Testimonials - Hear From Our Clients</title>
                <meta name="description" content="Read what our clients have to say about our services. Glyph has consistently delivered cutting-edge solutions to help businesses grow." />
                <meta name="keywords" content="testimonials, client reviews, business success, Glyph tech solutions" />
                <meta name="author" content="Glyph Tech Solutions" />
            </Helmet>
            <ServicesSectionProvider>
                <div className="container-fluid mt-5 pt-5">
                    <Cursor />
                    <Header />
                    {
                        loading ?
                            (
                                <>
                                    <ActiveTestimonial testimonial={testimonialsData[0]} />
                                    <Testimonials
                                        testimonials={testimonialsData}
                                        onTestimonialClick={handleTestimonialClick}
                                    />
                                </>

                            ) :
                            (
                                <>
                                    <ActiveTestimonial testimonial={activeTestimonial} />
                                    <Testimonials
                                        testimonials={testimonials}
                                        onTestimonialClick={handleTestimonialClick}
                                    />
                                </>
                            )
                    }
                </div>
            </ServicesSectionProvider>
        </>
    );
};

export default Testimonial;

